
export function isConnectionError(exception = {}) {
  const {error} = exception;
  if (error) return isConnectionErrorCheck(error);
  return isConnectionErrorCheck(exception);
}

function isConnectionErrorCheck({url, status, code}) {
  return (url && !status) || code === 'ECONNABORTED';
}